export const inquiryList = [
  { name: "김ㅇㅇ", subject: "교통사고 손해액 문의", date: "2026-07-09", tag: "상담신청" },
  { name: "박ㅇㅇ", subject: "근재보험 보상금 청구", date: "2026-07-08", tag: "상담신청" },
  { name: "이ㅇㅇ", subject: "개인보험 암진단비", date: "2026-07-07", tag: "상담신청" },
  { name: "전ㅇㅇ", subject: "누수사고 손해배상", date: "2026-07-06", tag: "상담신청" },
  { name: "최ㅇㅇ", subject: "화재보험금 지급거절", date: "2026-07-02", tag: "상담신청" },
  { name: "정ㅇㅇ", subject: "실손보험 청구", date: "2026-06-30", tag: "상담완료" },
  { name: "홍ㅇㅇ", subject: "손해배상 책임 범위", date: "2026-06-28", tag: "상담신청" },
  { name: "오ㅇㅇ", subject: "교통사고 후유장해", date: "2026-06-25", tag: "상담완료" },
];

export const values = [
  {
    en: "Professionalism",
    ko: "전문성과 신뢰",
    desc: "고객의 권리를 지키는 데 최선을 다하며, 정직하고 투명한 손해사정 서비스를 제공합니다.",
    img: "https://storage.readdy-site.link/project_files/2836f450-9c16-4795-8079-772e594f98c3/8c7d948f-caea-477e-887b-8671fcbfaeba_compressed_unnamed.webp",
    icon: "ri-briefcase-line",
  },
  {
    en: "Network",
    ko: "전문가 네트워크",
    desc: "법률, 의료, 보험 등 다양한 분야의 전문가들과 협업하여 고객에게 최상의 솔루션을 제공합니다.",
    img: "https://readdy.ai/api/search-image?query=Korean%20business%20team%20collaboration%20meeting%20around%20conference%20table%20with%20laptops%20and%20documents%2C%20warm%20natural%20light%2C%20modern%20Korean%20corporate%20office%2C%20Asian%20professional%20teamwork%20concept%2C%20editorial%20photography%2C%20warm%20neutral%20and%20burgundy%20accent%20tones&width=800&height=600&seq=dada-value-net-02&orientation=landscape",
    icon: "ri-team-line",
  },
  {
    en: "Accuracy",
    ko: "정확한 손해사정 평가",
    desc: "정확한 자료 분석과 객관적인 평가를 통해 고객의 손해를 정확하게 산정하고 정당한 보상을 받을 수 있도록 지원합니다.",
    img: "https://readdy.ai/api/search-image?query=Close-up%20of%20magnifying%20glass%20over%20insurance%20documents%20and%20calculator%20on%20wooden%20desk%2C%20soft%20warm%20lighting%2C%20professional%20audit%20and%20analysis%20concept%2C%20editorial%20photography%2C%20dark%20burgundy%20and%20cream%20warm%20tones&width=800&height=600&seq=dada-value-acc-03&orientation=landscape",
    icon: "ri-search-line",
  },
];

export const services = [
  {
    ttl: "개인보험",
    en: "Personal Insurance",
    desc: "암진단비, 심뇌혈관질환, 사망·후유장해 등 개인보험 관련 분쟁을 전문적으로 처리합니다. 보험사의 부지급·감액 처분에 적극 대응합니다.",
    icon: "ri-shield-user-line",
    tags: ["암진단비", "심뇌혈관", "후유장해", "실손보험"],
  },
  {
    ttl: "근재보험",
    en: "Workers Compensation",
    desc: "산재보험만으로는 보상되지 않는 초과 손해액을 객관적으로 산정합니다. 산재 종결 후에도 남아 있는 손해액에 대해 근재보험을 통해 정당한 보상을 받으실 수 있도록 체계적으로 지원합니다.",
    icon: "ri-building-line",
    tags: ["산재초과손해액", "업무상재해", "보상금산정", "후유장해"],
  },
  {
    ttl: "교통사고",
    en: "Traffic Accident",
    desc: "교통사고 처리, 손해액 산정, 과실비율 검토 등 교통사고와 관련된 모든 손해사정 업무를 신속하고 정확하게 처리해 드립니다.",
    icon: "ri-car-line",
    tags: ["손해액산정", "과실비율", "후유장해", "대인보상"],
  },
  {
    ttl: "손해배상",
    en: "Damage Compensation",
    desc: "배상책임, 영조물 손해, 민사상 손해배상 청구 등 다양한 손해배상 분쟁에 대해 객관적인 손해액을 산정하고 보상을 도와드립니다.",
    icon: "ri-scales-3-line",
    tags: ["배상책임", "영조물손해", "손해액산정", "민사분쟁"],
  },
  {
    ttl: "화재",
    en: "Fire Insurance",
    desc: "화재 현장 조사, 화재원인 규명, 재산피해 산정 등 화재와 관련된 손해사정 업무를 전문가의 시선으로 정확하게 평가합니다.",
    icon: "ri-fire-line",
    tags: ["화재보험금", "원인규명", "재산피해", "산정평가"],
  },
  {
    ttl: "누수",
    en: "Water Leakage",
    desc: "누수사고로 인한 재산피해, 하자보수비용, 배상책임 등 누수와 관련된 손해액을 객관적으로 산정하고 공정한 보상을 받을 수 있도록 지원합니다.",
    icon: "ri-drop-line",
    tags: ["누수피해", "재산피해", "하자보수", "배상산정"],
  },
];

export const steps = [
  {
    step: "01",
    ttl: "고객의뢰 · 사고상담",
    desc: "사고 경위와 계약 내용을 종합 청취하고 예상 쟁점을 사전 파악합니다.",
    icon: "ri-chat-3-line",
  },
  {
    step: "02",
    ttl: "고객면담 · 계약체결",
    desc: "진행 절차와 예상 일정을 안내하고 위임 계약을 체결합니다.",
    icon: "ri-file-list-3-line",
  },
  {
    step: "03",
    ttl: "현장조사 · 근거확보",
    desc: "사고 현장 및 관련 기관을 방문하여 필요한 자료와 근거를 확보합니다.",
    icon: "ri-search-eye-line",
  },
  {
    step: "04",
    ttl: "손해사정서 작성 · 제출",
    desc: "수집된 자료를 바탕으로 객관적이고 정확한 손해사정서를 작성하여 제출합니다.",
    icon: "ri-file-text-line",
  },
  {
    step: "05",
    ttl: "보험사 심사 · 분쟁대응",
    desc: "보험사 조사 및 이의제기 단계에서 의견진술을 적극 수행합니다.",
    icon: "ri-scales-3-line",
  },
  {
    step: "06",
    ttl: "보험금 지급 · 결정",
    desc: "지급 결과 안내 및 부지급 시 보정·이의절차 대응을 지원합니다.",
    icon: "ri-check-double-line",
  },
];

export const cases = [
  {
    ttl: "교통사고 손해액 3배 인상 성공 사례",
    summary: "보험사에서 제시한 초기 손해액이 과도하게 낮게 책정되어 있었으나, 객관적인 손해액 산정과 근거 자료 제출로 3배 이상의 손해액을 확보했습니다.",
    date: "2025-11-30",
    tag: "교통사고",
    img: "https://readdy.ai/api/search-image?query=Korean%20insurance%20adjuster%20reviewing%20traffic%20accident%20documents%20and%20damage%20photos%20on%20desk%2C%20dark%20office%20interior%20with%20burgundy%20accent%20wall%2C%20warm%20natural%20light%2C%20Asian%20professional%20in%20modern%20Korean%20office%2C%20editorial%20photography%2C%20sophisticated%20corporate%20atmosphere&width=900&height=600&seq=dada-case-traffic-01&orientation=landscape",
  },
  {
    ttl: "근재보험 업무상재해 인정 및 보상금 확보",
    summary: "산재보험 종결 후에도 휴업손해·위자료 등 초과 손해액이 남아 있었으나, 근재보험을 통해 산재보험 초과분까지 객관적으로 산정하여 정당한 보상금을 확보했습니다.",
    date: "2025-10-15",
    tag: "근재보험",
    img: "https://readdy.ai/api/search-image?query=Korean%20safety%20inspector%20examining%20workplace%20accident%20scene%20with%20clipboard%20and%20measurement%20tools%2C%20Korean%20factory%20interior%20with%20safety%20signs%2C%20Asian%20professional%20at%20work%2C%20warm%20neutral%20lighting%2C%20editorial%20photography%2C%20dark%20burgundy%20and%20cream%20tones&width=900&height=600&seq=dada-case-workers-02&orientation=landscape",
  },
  {
    ttl: "화재보험금 지급거절 취소 및 전액 지급",
    summary: "화재보험금 지급이 거절된 사건에서 화재원인 재조사와 재산피해 재산정을 통해 지급거절 처분을 취소하고 전액 지급을 이끌어냈습니다.",
    date: "2025-09-14",
    tag: "화재",
    img: "https://readdy.ai/api/search-image?query=Korean%20fire%20damage%20evaluator%20inspecting%20burned%20property%20interior%20with%20clipboard%2C%20careful%20documentation%20and%20measurement%2C%20warm%20dramatic%20lighting%20from%20window%2C%20Asian%20professional%20on%20site%2C%20editorial%20photography%2C%20dark%20burgundy%20and%20warm%20neutral%20color%20palette&width=900&height=600&seq=dada-case-fire-03&orientation=landscape",
  },
  {
    ttl: "누수사고 재산피해 손해액 산정 성공",
    summary: "아파트 누수로 인한 재산피해 금액이 부실하게 산정되었으나, 객관적인 피해 범위 재조사와 전문 감정을 통해 정당한 배상금을 확보했습니다.",
    date: "2025-08-20",
    tag: "누수",
    img: "https://readdy.ai/api/search-image?query=Korean%20water%20damage%20inspector%20checking%20moisture%20meter%20and%20ceiling%20stains%20in%20modern%20Korean%20apartment%20interior%2C%20soft%20natural%20window%20light%2C%20Asian%20professional%20at%20work%2C%20editorial%20photography%2C%20warm%20neutral%20and%20burgundy%20accent%20tones&width=900&height=600&seq=dada-case-leak-04&orientation=landscape",
  },
  {
    ttl: "개인보험 암진단비 부지급 처분 취소",
    summary: "암진단비 청구가 고지의무 위반으로 부지급 처리되었으나, 계약 체결 시 고지 범위에 대한 법리 검토를 통해 부지급 처분을 취소하고 전액 지급받았습니다.",
    date: "2025-07-10",
    tag: "개인보험",
    img: "https://readdy.ai/api/search-image?query=Medical%20diagnosis%20documents%20with%20stethoscope%20and%20insurance%20claim%20forms%20on%20wooden%20desk%2C%20soft%20warm%20natural%20light%20from%20side%20window%2C%20editorial%20healthcare%20photography%2C%20dark%20burgundy%20and%20cream%20warm%20tones%2C%20professional%20clinical%20atmosphere&width=900&height=600&seq=dada-case-insurance-05&orientation=landscape",
  },
  {
    ttl: "손해배상 책임 범위 확정 및 배상금 확보",
    summary: "복수의 책임 주체가 얽힌 손해배상 사건에서 각 주체의 배상책임 범위를 명확히 규정하고, 의뢰인이 정당한 배상금을 받을 수 있도록 지원했습니다.",
    date: "2025-06-22",
    tag: "손해배상",
    img: "https://readdy.ai/api/search-image?query=Korean%20legal%20professional%20reviewing%20liability%20documents%20and%20contract%20papers%20in%20elegant%20Korean%20law%20office%2C%20soft%20natural%20window%20light%2C%20wooden%20desk%20with%20elegant%20fountain%20pen%2C%20Asian%20attorney%20portrait%2C%20editorial%20photography%2C%20dark%20burgundy%20and%20warm%20cream%20tones&width=900&height=600&seq=dada-case-comp-06&orientation=landscape",
  },
];

export const faqs = [
  {
    q: "손해사정은 어떤 서비스인가요?",
    a: "사고로 인해 발생한 손해의 정도와 보상금액을 객관적으로 평가하고, 보험사와 가입자 간의 분쟁을 조정하는 전문 서비스입니다. 다다손해사정은 고객의 편에서 정당한 보상을 받을 수 있도록 지원합니다.",
  },
  {
    q: "상담 비용은 어떻게 되나요?",
    a: "5분 이내 간단 상담은 무료로 진행됩니다. 기본 상담은 30분당 10만원의 상담료가 발생하며, 사건 수임 후에는 성공보수 방식으로 진행합니다.",
  },
  {
    q: "보험사에서 이미 부지급 통보를 받았는데 재청구가 가능한가요?",
    a: "부지급 처분 이후에도 소멸시효(대개 3년) 이내라면 재청구 및 이의제기가 가능합니다. 새로운 근거 자료를 통해 반전 인정된 사례가 다수 있습니다.",
  },
  {
    q: "지방에 거주하는데 상담이 가능한가요?",
    a: "전국 어디서든 유선·화상 상담이 가능하며, 필요시 담당 손해사정사가 직접 방문하여 자료 검토와 현장 조사를 진행합니다.",
  },
  {
    q: "진행 기간은 얼마나 걸리나요?",
    a: "쟁점의 복잡도에 따라 다르지만, 평균 3~8주 이내에 손해사정서 제출까지 진행됩니다. 진행 상황은 단계별로 실시간 공유해 드립니다.",
  },
];